import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDraftingCompass,
  faCogs,
  faLeaf,
  faThLarge,
} from "@fortawesome/free-solid-svg-icons";

const features = [
  {
    icon: faDraftingCompass,
    title: "Visionary Planning",
    text: "Turning ideas into detailed, achievable yellowprints.",
  },
  {
    icon: faCogs,
    title: "Detailed Engineering",
    text: "Seamlessly integrating strength with aesthetic appeal.",
  },
  {
    icon: faLeaf,
    title: "Sustainable Approach",
    text: "Balancing beauty with environmental responsibility.",
  },
  {
    icon: faThLarge,
    title: "Design Expertise",
    text: "Blending modern concepts with classic architectural values.",
  },
];

const Stats = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 md:gap-8 w-full py-10 bg-gray-50 lg:px-32 px-5">
      {features.map((item, index) => (
        <div
          key={index}
          className="bg-white rounded-3xl shadow-sm p-8 text-center flex flex-col items-center border border-gray-100"
        >
          <div className="bg-gray-100 rounded-full p-6 mb-4">
            <FontAwesomeIcon
              icon={item.icon}
              className="text-yellow-600 text-3xl"
            />
          </div>

          <h3 className="text-xl font-semibold mb-2 text-black">{item.title}</h3>

          <div className="w-20 border-b border-gray-200 mb-4"></div>

          <p className="text-gray-600 text-sm leading-relaxed">{item.text}</p>
        </div>
      ))}
    </div>
  );
};

export default Stats;
